import React, {useContext} from 'react';

export interface Auth {
    isAuthenticated: boolean;
    username: string;
    hasRole: (role: string) => boolean;
}

export const AuthContext = React.createContext<Readonly<Auth>>({
    isAuthenticated: false,
    username: '',
    hasRole: () => false
});

export function useAuth() {
    return useContext(AuthContext);
}
